import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import { AuthContext } from '../../../../contexts/AuthContext';
import { Modules, RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum } from '../../../../enums';
import { hasResourseAccess } from '../../../../utils/methods';

interface HeaderProps {
  isAddMode: boolean;
}

const Header: React.FC<HeaderProps> = ({ isAddMode }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.PropertyVisit]: [PermissionActionsEnum.Add] }],
  });

  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.PropertyVisit]: [PermissionActionsEnum.View] }],
  });

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">
          {isAddMode
            ? t('propertyVisits.addEditView.pageTexts.header.addTitle')
            : t('propertyVisits.addEditView.pageTexts.header.editTitle')}
        </h4>
        <p>
          {isAddMode
            ? t('propertyVisits.addEditView.pageTexts.header.addSubtitle')
            : t('propertyVisits.addEditView.pageTexts.header.editSubtitle')}
        </p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end gap-3">
        {!isAddMode && hasAddAccess && (
          <Button
            className="btn btn-primary waves-effect waves-light"
            text={t('propertyVisits.addEditView.pageTexts.header.addNew')}
            onClick={() => navigate(`${Modules.propertyVisits}${RouteParamsTypes.add}`)}
          />
        )}
        {hasListAccess && (
          <Button
            className="btn btn-primary waves-effect waves-light"
            text={t('propertyVisits.addEditView.pageTexts.header.goToList')}
            onClick={() => navigate(Modules.propertyVisits)}
          />
        )}
      </div>
    </div>
  );
};

export default Header;
